module.exports = __webpack_public_path__ + "img/lagerausbildung-1bohrung-en.fd99852b.png";